import { BodyText, Button, FlexRow, Grid, ModalWindow } from '../../../ui-toolkit';
import React from 'react';
import { ClientUrlFactory } from '../../../ui-toolkit/rest/ClientUrlFactory';
import { useHistory } from 'react-router-dom';

interface IGeneratePdfModal {
  orderId: string;
  onClose: () => void;
}
export const GeneratePdfModal: React.FC<IGeneratePdfModal> = ({ orderId, onClose }) => {
  const history = useHistory();

  return (
    <ModalWindow mode={'transition'} title={'Generating PDF'}>
      <Grid>
        <BodyText>
          Documents are generating, this may take a few minutes. Redirect to documents tab or close to stay on the fees
          tab.
        </BodyText>
        <FlexRow justifyContent={'flex-end'}>
          <Button
            intent={'primary'}
            onClick={() => history.push(ClientUrlFactory().urlFor.documentsIndex(orderId!))}
            data-test-id={'redirect-button'}
          >
            Go to Documents
          </Button>
          <Button intent={'danger'} onClick={onClose} data-test-id={'close-button'}>
            Close
          </Button>
        </FlexRow>
      </Grid>
    </ModalWindow>
  );
};
